<template>
<div class="page-bar">
  <ul>
    <li><a @click="selectPage(1)">首页</a></li>
    <li><a @click="prePage">上一页</a></li>
    <li v-for="index in pageNoList">
      <a :class="index==currentPage?'current-page':''" @click="selectPage(index)">{{index}}</a>
    </li>
    <li><a @click="nextPage">下一页</a></li>
    <li><a @click="selectPage(totalPage)">尾页</a></li>
    <li><a>共{{totalPage}}页</a></li>
    <li><a>{{pageSize}}条/页</a></li>
    <li><a>共{{totalCount}}条</a></li>
  </ul>
</div>
</template>
<script>
export default {
  name: 'Pagination',
  props: {
    page: {
      type: Object,
      default: function () {
        return {
          page: {
            total: 0,
            page: 1,
            pageSize: 10
          }
        }
      }
    },
    other: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      maxIndex: 5
    }
  },
  created: function () {
    // console.log("componet is created");
    // console.log('分页componet is created:' + JSON.stringify(this.page))
    // this.selectPage(1);
  },
  computed: {
    pageAttr: function () {
      let that = this
      if (JSON.stringify(this.page) == '{}') {
        return {page: 0, total: 0, pageSize: 10}
      } else {
        return that.page.page
      }
    },
    currentPage: function () {
      let that = this
      // let pageAttr=that.page.page;
      // console.log('分页componet is computed:' + JSON.stringify(that.pageAttr))
      return that.pageAttr.page
    },
    pageSize: function () {
      let that = this
      // let pageAttr=that.page.page;
      return that.pageAttr.pageSize
    },
    totalCount: function () {
      let that = this
      // let pageAttr=that.page.page;
      return that.pageAttr.total
    },
    totalPage: function () {
      let that = this
      // let pageAttr=that.page.page;
      let y = that.pageAttr.total % that.pageAttr.pageSize
      // console.log("computed求余:"+y+"|page.total="+page.total+"|pageSize="+page.pageSize);
      if (y == 0) {
        return parseInt(that.pageAttr.total / that.pageAttr.pageSize)
      } else {
        return parseInt(that.pageAttr.total / that.pageAttr.pageSize) + 1
      }
    },
    pageNoList: function () {
      let that = this
      let centerIndex = parseInt(that.maxIndex / 2)
      let startIndex = (that.currentPage - centerIndex)
      // console.log("startIndex:"+startIndex);
      if (startIndex <= 0) {
        startIndex = 1
      }
      let contPage = 0
      if (that.totalPage > that.maxIndex) {
        contPage = that.maxIndex
      } else {
        contPage = that.totalPage
        startIndex = 1
      }
      let newNoPageList = []
      for (let i = 0; i < contPage; i++) {
        if (startIndex <= that.totalPage) {
          // console.log("push to array:"+startIndex);
          newNoPageList.push(startIndex)
          startIndex++
        }
      }
      // console.log("newPageList:"+JSON.stringify(newPageList));
      return newNoPageList
    }

  },
  methods: {
    initComponent () { // 已废弃
      let that = this
      let y = that.total % that.pageSize
      // console.log('求余:' + y + '|that.total=' + that.total + '|that.pageSize=' + that.pageSize)
      if (y == 0) {
        that.totalPage = that.total / that.pageSize
      } else {
        that.totalPage = that.total / that.pageSize + 1
      }
      // console.log('totalPage:' + that.totalPage)
      let contPage = 0
      let startIndex = 1
      if (that.totalPage > that.maxIndex) {
        contPage = that.maxIndex
      } else {
        contPage = that.totalPage
      }
      let newNoPageList = []
      for (let i = 0; i < contPage; i++) {
        if (startIndex <= that.totalPage) {
          // console.log("push to array:"+startIndex);
          newNoPageList.push(startIndex)
          startIndex++
        }
      }
      // console.log("newPageList:"+JSON.stringify(newPageList));
      that.pageNoList = newNoPageList
    },

    selectPage (pageIndex) {
      // console.log("选择页码："+pageIndex);
      let that = this
      that.page.page.page = pageIndex
      // console.log("回调参数："+pageIndex);
      that.$emit('queryData', that.page.page)
    },
    prePage () {
      let that = this
      if (that.currentPage > 1) {
        that.page.page.page = that.page.page.page - 1
      }
      that.selectPage(that.page.page.page)
    },
    nextPage () {
      let that = this
      if (that.page.page.page < that.totalPage) {
        that.page.page.page = that.page.page.page + 1
      }
      that.selectPage(that.page.page.page)
    },
    reLoadPageList () { // 已废弃
      let that = this

      let centerIndex = parseInt(that.maxIndex / 2)
      let startIndex = (that.currentPage - centerIndex)
      // console.log("startIndex:"+startIndex);
      if (startIndex <= 0) {
        startIndex = 1
      }
      let contPage = 0
      if (that.totalPage > that.maxIndex) {
        contPage = that.maxIndex
      } else {
        contPage = that.totalPage
      }
      let newPageList = []
      for (let i = 0; i < contPage; i++) {
        if (startIndex <= that.totalPage) {
          // console.log("push to array:"+startIndex);
          newPageList.push(startIndex)
          startIndex++
        }
      }
      // console.log("newPageList:"+JSON.stringify(newPageList));
      that.pageNoList = newPageList
    }
  }
}
</script>
<style scoped>
.item-action li:before {
  content: "样式：";
}

.page-bar {
  width:100%;
  height:60px;
  margin-top: 10px;
}

.page-bar ul{
  display: flex;
  justify-content:center;
  height:60px;
  width: 100%;
}

.page-bar li {
  list-style: none;
  float:left;
}

.page-bar li:first-child>a {
  margin-left: 0px
}

.page-bar a {
  height: auto;
  display:block;
  border: 1px solid #ddd;
  text-decoration: none;

  padding: 6px 12px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: #5D6062;
  cursor: pointer;
  margin-right: 4px;
}

.page-bar a:hover {
  background-color: #5eb1e8;
  color: #fff;
}

.page-bar .current-page {
  background-color: var(--color6);
  color: #fff;
}

.page-bar a.banclick {
  cursor: not-allowed;
}

.page-bar .active a {
  color: #fff;
  cursor: default;
  background-color: #E96463;
  border-color: #E96463;
}

.page-bar i {
  font-style: normal;
  color: #d44950;
  margin: 0px 4px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/utils/Pagination.vue